export default "__VITE_ASSET__7jpxxEQG__"